/**
 * JWT storage helpers. Per frontend/CLAUDE.md, the JWT lives in
 * localStorage under the key `dax_bot_jwt` and is sent as
 * `Authorization: Bearer ...` on every API call. Centralising the
 * key here means the API client and AuthContext never type the
 * literal twice.
 */
export const JWT_STORAGE_KEY = "dax_bot_jwt";
export const LAST_EMAIL_STORAGE_KEY = "dax_bot_last_email";

export function readJwt(): string | null {
  if (typeof localStorage === "undefined") return null;
  const v = localStorage.getItem(JWT_STORAGE_KEY);
  return v && v.length > 0 ? v : null;
}

export function writeJwt(token: string): void {
  if (typeof localStorage === "undefined") return;
  localStorage.setItem(JWT_STORAGE_KEY, token);
}

export function clearJwt(): void {
  if (typeof localStorage === "undefined") return;
  localStorage.removeItem(JWT_STORAGE_KEY);
}

export function readLastEmail(): string | null {
  if (typeof localStorage === "undefined") return null;
  return localStorage.getItem(LAST_EMAIL_STORAGE_KEY);
}

export function writeLastEmail(email: string): void {
  if (typeof localStorage === "undefined") return;
  localStorage.setItem(LAST_EMAIL_STORAGE_KEY, email);
}
